'use client';

import React, { Component } from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleReport = () => {
    const subject = encodeURIComponent('Bug Report - PuiPi');
    const body = encodeURIComponent(
      `Error: ${this.state.error?.message || 'Unknown error'}\nURL: ${window.location.href}\nTime: ${new Date().toISOString()}`
    );
    window.location.href = `mailto:support@puipi.com?subject=${subject}&body=${body}`;
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            {/* Sad dog illustration */}
            <div className="error-illustration">
              <div className="error-swirl">@</div>
              <div className="sad-dog">
                <div className="dog-body">
                  <div className="dog-head">
                    <div className="dog-ear-left" />
                    <div className="dog-ear-right" />
                    <div className="dog-eye-left" />
                    <div className="dog-eye-right" />
                    <div className="dog-mouth" />
                    <div className="dog-tear" />
                  </div>
                </div>
              </div>
            </div>

            <h2 className="error-boundary-title">Oops! 出了一點問題</h2>
            <p className="error-boundary-message">
              很抱歉，頁面發生了一些錯誤。請試著重新載入頁面，如果問題持續存在，請回報問題。
            </p>

            <div className="error-boundary-actions">
              <button className="error-reload-btn" onClick={this.handleReload}>
                重新載入
              </button>
              <button className="error-report-link" onClick={this.handleReport}>
                回報問題
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
